import { render, staticRenderFns } from "./newAgency.vue?vue&type=template&id=3da722db&"
import script from "./newAgency.vue?vue&type=script&lang=js&"
export * from "./newAgency.vue?vue&type=script&lang=js&"
import style0 from "./newAgency.vue?vue&type=style&index=0&id=3da722db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports